import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../Shared/Consts";
import queryString from 'query-string';
import logo_picturenaming from '../assets/images/app-picturenaming.png';

import ico_correct from '../assets/images/correct.png';
import ico_wrong from '../assets/images/wrong.png';
import HeaderComponent from "../Shared/Header";
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import connect from "react-redux/es/connect/connect";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import logo_kidsign from "../assets/images/app-kidsignsay.png";
import DropDownNotifications from "../Shared/DropDownNotifications";
import ReportBugForm from "../ModalFormComponents/ReportBugForm";
import {updateStudent} from "./actions";
import {Overlay, Popover} from "react-bootstrap";
import ReactDOM from "react-dom";

import pauseBtn from '../assets/images/ico_pause_white.png';
import playBtn from '../assets/images/ico_play_white.png';
import prevBtn from '../assets/images/ico_prev_white.png';
import nextBtn from '../assets/images/ico_next_white.png';
import restartBtn from '../assets/images/ico_restart_white.png';

import closeRedX from "../assets/images/modal_x.png";
import arrowIcon from "../assets/images/hint-arrow.png";
import TRACKING from "../Shared/DataTrackingPoints";
import {Modal} from "react-bootstrap";


class PNGrading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testId: null,
            gradeStart: null,
            paused: true,
            timerInterval:null,
            bestScores: null,
            rejectedReason: '',
            recording: false,
            imageSrc: "",
            videoSrc: "",
            currentWord:"",
            currentIndex:-1,
            pnPicture: null,
            studentJoined: false,
            pnPictures: [],
            pnSession:null,
            modalDialog:false,
            responseContent:'',
            modalDialogDelete: false,
            modalDialogNote: false,
            noteContent:'',
            handleNext: false,
            taskID:null,
            showStartHint:false,
            showReScoreHint: false,
            showSaveHint: false,
            play:false,
            sessionData: {
                testId: null,
                gradingTime: 60,
                numberCorrect: 0,
                numberIncorrect: 0,
                numberSkipped: 0,
                endLevel: 1,
                endProgress: 20,
                pnPictures: [],
                // guid: require('uuid/v4')()
            },
            analytics: {
                type: null,
                metadata: null,
            }
        };

        this.startGrading = this.startGrading.bind(this);
        this.startPictureGrading = this.startPictureGrading.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.gradePNPicture = this.gradePNPicture.bind(this);
        this.submitPNSessionGrade = this.submitPNSessionGrade.bind(this);
        this.pause = this.pause.bind(this);
        this.changeImage = this.changeImage.bind(this);
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.updatePNBestScore = this.updatePNBestScore.bind(this);
        this.getGradeCounts = this.getGradeCounts.bind(this);
        this.deleteScore = this.deleteScore.bind(this);
        this.handleTakeANote = this.handleTakeANote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.handleNoteClose = this.handleNoteClose.bind(this);
        this.handleNoteContentChange = this.handleNoteContentChange.bind(this);
        this.handleStudentClick = this.handleStudentClick.bind(this);
        this.handleNextTask = this.handleNextTask.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.getTarget1 = this.getTarget1.bind(this);
        this.handleShowHints = this.handleShowHints.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    async componentDidMount() {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        console.log(parsed);
        await this.setState({
            testId: parsed.testId,
            gradeStart: Date.now(),
            analytics:{
                type: TRACKING.PN_SCORE_VIEW,
                metadata:{testId:parsed.testId}
            }
        });
        this.startGrading(parsed.testId);
        REST.getStudentNotifications().then(res => {
            for(let i = 0; i < res.body.length; i++){
                for(let j=0; j<res.body[i].apps.pictureNamingScores.length; j++){
                    let pictureNamingScores = res.body[i].apps.pictureNamingScores[j];
                    if (pictureNamingScores && pictureNamingScores.userId === this.props.lastStudent.user.id && pictureNamingScores.id != parsed.testId) {
                        this.setState({
                            handleNext: true,
                            taskID: pictureNamingScores.id
                        });
                    }
                }
            }
        });
        this.handleAnalytics();
    };

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    componentWillUnmount(){
        clearInterval(this.state.timerInterval);
    }

    handleNextTask(){
        window.location.href = '/teacher/apps/pn-grading?testId=' + this.state.taskID;
    }

    async getGradeCounts(){
        let result = {
            numberCorrect: 0,
            numberIncorrect: 0,
            numberSkipped: 0,
        };
        for(let pnPic of this.state.pnPictures){
            if(pnPic.pn_assessments_picture.grade === 1){
                result.numberCorrect = result.numberCorrect+1;
            }else if(pnPic.pn_assessments_picture.grade === 2) {
                result.numberIncorrect = result.numberIncorrect+1;
            }else{
                result.numberSkipped = result.numberSkipped+1;
            }
        }
        await this.setState({
            sessionData:{
                ...this.state.sessionData,
                ...result
            }
        });
        return result;
    }

    async updatePNBestScore(){
        console.log('bestScores');
        console.log(this.state.bestScores);
        console.log('pnSession');
        console.log(this.state.pnSession);
        if(this.state.bestScores.pnLevel === this.state.pnSession.startLevel){//not clear
        //if(this.state.bestScores.pnLevel === this.state.pnSession.startLevel && this.state.bestScores.pnScore === this.state.pnSession.startProgress{
            let newProgress = this.state.bestScores.pnScore;
            let newLevel = this.state.bestScores.pnLevel;
            if (this.state.pnSession.startLevel === 1) {
                if (this.state.sessionData.numberCorrect === 12) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.pnSession.startLevel === 2) {
                if (this.state.sessionData.numberCorrect === 15) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.pnSession.startLevel === 3) {
                if (this.state.sessionData.numberCorrect >= 18) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }

            if (newProgress >= 4 && newLevel <= 3) {
                newLevel++;
                newProgress = 1;
            } else if (newProgress === 0) {
                //newLevel--;
                newProgress = 1;
            }

            await this.setState({
                bestScores: {
                    ...this.state.bestScores,
                    pnLevel: newLevel,
                    pnScore: newProgress
                }
            });

            await REST.updatePNBestScore(this.state.bestScores);
        }
    }

    submitPNSessionGrade = async () => {
        this.state.sessionData.testId = this.state.testId;

        await this.setState({
            sessionData:{
                ...this.state.sessionData,
                testId:this.state.testId,
                gradingTime: Math.ceil((Date.now() - this.state.gradeStart)/1000)
            }
        });

        await this.getGradeCounts();
        console.log("Submitting session data: ", this.state.sessionData);
        await REST.gradePNSession(this.state.sessionData).then(async(res)=>{
            if(this.state.pnSession && this.state.pnSession.assessmentType===0) {
                await this.updatePNBestScore();
            }
            this.setState({
                modalDialog: true,
                responseContent:'Score task saved.',
                analytics: {
                    type: TRACKING.PN_SCORE_SAVE,
                    metadata: {testId: this.state.testId}
                }
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        this.handleAnalytics();
    };

    startGrading = (testId) => {
        REST.getPNManualSession(testId).then(async(res) => {
            let pnSession = res.body;
            if (pnSession) {
                let bestScores = await REST.getStudentBestScores(pnSession.userId);
                this.setState({
                    pnSession:pnSession,
                    bestScores:bestScores.body,
                    noteContent: pnSession.note,
                    pnPictures:pnSession.pn_pictures,
                    videoSrc:BUCKET_URL+pnSession.AV_FileName
                });
                this.video.src = BUCKET_URL+pnSession.AV_FileName;
                this.startPictureGrading(pnSession.pn_pictures);
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:'An Invalid Assessment ID has been provided.'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }

        }).catch(error => {
            this.setState({
                modalDialog: true,
                responseContent:'An Invalid Assessment ID has been provided.'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    };

    gradePNPicture(grade) {
        this.state.pnPicture.pn_assessments_picture.grade = grade;
        this.state.sessionData.pnPictures.push(this.state.pnPicture);
        if (grade === 1) {
            this.state.sessionData.numberCorrect = this.state.sessionData.numberCorrect + 1;
        } else if(grade === 2){
            this.state.sessionData.numberIncorrect = this.state.sessionData.numberIncorrect + 1;
        }else{
            this.state.sessionData.numberSkipped = this.state.sessionData.numberSkipped + 1;
        }
        this.next();
    }

    handleReset(){
        for (let i=0; i<this.state.pnPictures.length; i++) {
            this.state.pnPictures[i].pn_assessments_picture.grade = 0;
            this.state.sessionData.pnPictures.push(this.state.pnPictures[i]);
        }
        this.setState({
            sessionData: {
                ...this.state.sessionData,
                numberCorrect: 0,
                numberIncorrect: 0,
                numberSkipped: 0,
            }
        });
    }

    startPictureGrading(pnPictures){
        let i = 0;
        let prev = -1;
        let timer = setInterval(() => {
            if(!this.state.paused) {
                if(this.video.currentTime>=0.0 && this.video.currentTime<this.video.duration){
                    let timeInterval = (this.video.duration)/pnPictures.length;
                    i = Math.floor((this.video.currentTime)/timeInterval);
                    if(prev!==i) {
                        this.setState({
                            pnPicture:pnPictures[i],
                            imageSrc: pnPictures[i].url,
                            currentWord:pnPictures[i].word,
                            currentIndex:i
                        });
                    }
                    prev = i;
                }else{
                    this.setState({
                        pnPicture:null,
                        imageSrc: "",
                        currentWord:"",
                        currentIndex:-1
                    });
                }
            }
        },100);

        this.setState({
            timerInterval:timer
        });
    }

    async pause(pause) {
        this.setState({paused: pause});
        if(pause) {
            this.video.pause();
            this.setState({play:false});
        }else{
            this.video.play();
            await this.setState({
                play:true
            });
        }
    }

    changeImage(index){
        if(this.state.pnSession.assessmentType === 0) {
            let timeInterval = (this.video.duration) / this.state.pnPictures.length;
            this.video.currentTime = Math.ceil(index * timeInterval);
            this.pause(false);
        }else if(this.state.pnSession.assessmentType === 1 ){
            let ap = this.state.pnPictures[index];
            this.setState({
                pnPicture:ap,
                imageSrc: ap.url,
                currentIndex:index,
                currentWord:ap.word
            });
            this.pause(true);
        }
    }

    prev(){
        if(this.state.currentIndex>0){
            this.changeImage(this.state.currentIndex-1);
        }
    }

    next(){
        if(this.state.currentIndex<this.state.pnPictures.length-1){
            this.changeImage(this.state.currentIndex+1);
        }else {
            if(this.state.pnSession.assessmentType === 0) {
                this.video.currentTime = this.video.duration;
            }
            this.pause(true);
        }
    }

    async deleteScore(){
        await this.setState({
            analytics: {
                type: TRACKING.PN_SCORE_DELETE,
                metadata: {testId: this.state.testId},
            }
        });
        await REST.deletePictureNamingScore(this.state.testId).then(res => {
            this.handleAnalytics();
            this.props.history.goBack();
        });
    }

    deleteScoreConfirm = (confirm) =>{
        if(confirm) {
            this.deleteScore();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleTakeANote(){
        console.log("take a note");
        this.setState({
            modalDialogNote:true,
        });
    }

    handleNoteContentChange(event) {
        this.setState({ noteContent: event.target.value });
        event.preventDefault();
    }

    saveNote(){
        REST.updatePNNote({testId:this.state.testId, note:this.state.noteContent});
        this.setState({
            modalDialogNote:false,
        });
    }

    deleteNote(){
        this.setState({noteContent:''});
        REST.updatePNNote({testId:this.state.testId, note:''});
    }

    handleNoteClose(){
        this.setState({
            modalDialogNote:false,
        });
    }

    handleStudentClick = (student, classId) => {
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    getTarget(){
        this.setState({
            showStartHint: false
        });
    }
    getTarget1() {
        this.setState({
            showReScoreHint: false
        });
    }
    handleShowHints(){
        this.setState({
            showStartHint: true, showReScoreHint: true, showSaveHint: true
        })
    }

    async handlePlay(){
        if(this.state.play){
            this.video.pause();
            this.setState({play:false});
        }
        else{
            this.video.play();
            await this.setState({
                play:true,
            });
        }
    }

    async handleSurveyBack(){
    }

    render() {
        let imageThumbnails = this.state.pnPictures.map((pnPic,index)=>{

            let gradeSrc = "";
            if(pnPic.pn_assessments_picture.grade === 1){
                gradeSrc = ico_correct;
            }else if(pnPic.pn_assessments_picture.grade === 2){
                gradeSrc = ico_wrong
            }

            return(<div key={index} style={{position:'relative',display:"inline-block",paddingTop:"20px",paddingLeft:"20px", paddingBottom:"20px",paddingRight:"20px"}}>
                <img style={{ position:"absolute", top: "10px",width:15, left: "0px", zIndex: 2}} src={gradeSrc} alt={""}/>
                <img style={{ position:"relative", top: "0px", left: "0px", zIndex: 1,cursor:'pointer'}} key={index} onClick={()=>this.changeImage(index)} src={pnPic.url} width="50" height="43" alt={pnPic.word}/>
            </div>)
        });
        console.log(this.props.lastStudent.user);
        let hideVideo = this.state.pnSession && this.state.pnSession.assessmentType === 1;
        return (
            <div>
                {/*<HeaderComponent notifications studentClick={this.handleStudentClick} gradingApps imageSrc={logo_picturenaming} appName={'Picture Naming Scoring'} sName={this.props.lastStudent} {...this.props}/>*/}
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DialogBox surveyModal role={'teacher'} app={'PNGrading'} userId={this.props.user.id} active={true} surveyBack={this.handleSurveyBack}/>
                <DeleteDialogBox
                    confirmDelete={this.deleteScoreConfirm}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <Modal id="dialogBox" show={this.state.modalDialogNote}>
                    <div className="modal-content">
                        <div className={"row modal-body"}>
                            {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                            <div className="section">
                                <h1 style={{paddingTop:0, marginTop:-10,marginBottom:15}}>Make a Note</h1>
                                <textarea
                                    style={{width:500}}
                                    onChange={this.handleNoteContentChange}
                                    value={this.state.noteContent}
                                    placeholder={"please enter your note here"}
                                ></textarea>
                            </div>
                            <div className="section" style={{marginTop:-40}}>
                                <div className={"col-md-4"}>
                                    <a style={{float:'left'}} onClick={this.deleteNote} className="handBtn">
                                        <span>Delete</span>
                                    </a>
                                </div>
                                <div className={"col-md-4"}>
                                    <a style={{float:'left'}} onClick={this.saveNote} className="handBtn">
                                        <span>Close</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <div className={"section bgGrey"} style={{paddingTop:10}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 noPadding mobileCenter">
                                    <div className="col-sm-5" style={{display:"flex"}}>
                                        <div>
                                           <h1><img src={logo_picturenaming} alt={"Picture Naming"} style={{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}/> {this.props.lastStudent.user.firstname} {this.props.lastStudent.user.lastname}</h1>
                                        </div>
                                        {hideVideo?
                                            <div style={{marginLeft:5, marginTop:9}}>
                                                <h4> (1-1 computer task)</h4>
                                            </div>:null}
                                        {hideVideo?
                                            <div style={{marginLeft:-220, marginTop:40}}>
                                                No Video in the scoring chart
                                            </div>
                                            :null}
                                    </div>
                                    <div className="col-sm-7 tr"><span className="descp"></span>
                                        <div className={"navbar"}> <ReportBugForm {...this.props} /><DropDownNotifications studentClick={this.handleStudentClick} {...this.props} /><a onClick={this.handleShowHints} className="handBtn"><span>Show Hints</span></a></div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <hr/>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                {/*<div className="col-lg-12 noPadding mobileCenter">*/}
                                {/*<div className="col-sm-4"><h1>Picture Naming Scoring</h1></div>*/}
                                {/*<div className="col-sm-8 tr"><span className="descp"></span>*/}
                                {/*</div>*/}
                                {/*<div className="clearfix"></div>*/}
                                {/*<hr/>*/}
                                {/*</div>*/}
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="row" style={{minHeight: "405px"}}>
                            <div className="col-lg-12">
                                <div className="col-lg-12 solidBorder">
                                    <div className="col-lg-12">
                                        <div hidden={hideVideo} className="col-lg-6 col-xs-6 col-md-6">
                                            <div className={"wrapper"}>
                                                <video id={"PictureNamingVidPlay"} controls={true} onClick={this.handlePlay} onPause={() => this.pause(true)}
                                                       onPlay={() => this.pause(false)} playsinline={true} ref={video => {
                                                    this.video = video
                                                }} width="100%" height="100%"/>
                                                <div className={!this.state.play ? "playpause" : ""} style={{cursor:'pointer'}} onClick={this.handlePlay}></div>
                                            </div>
                                            <br/><br/>

                                            <a className="btn btn-success btn-controls" hidden={!this.state.paused} onClick={() => this.pause(false)}><img
                                                src={playBtn} height="20" width="20"
                                                alt="Play"/> Play</a>
                                            <a className="btn btn-xs btn-blue btn-controls" hidden={this.state.paused} onClick={() => this.pause(true)}><img
                                                src={pauseBtn} height="20" width="20"
                                                alt="Pause"/> Pause </a>
                                            <a className="btn btn-info btn-controls" onClick={()=>this.prev()}><img
                                                src={prevBtn} height="20" width="30"
                                                alt="Prev"/> Prev</a>
                                            <a className="btn btn-info btn-controls" onClick={()=>this.next()}><img
                                                src={nextBtn} height="20" width="30"
                                                alt="Next"/> Next</a>
                                            <a className="btn btn-orange btn-controls" onClick={()=>this.changeImage(-1)}><img
                                                src={restartBtn} height="20" width="20"
                                                alt="Restart"/> Restart</a>
                                        </div>
                                        <div className={hideVideo ? "col-lg-12 tc" :"col-lg-6 col-xs-6 col-md-6"}>
                                            <div style={{marginBottom:10,position:'relative'}}>
                                                <div style={{display:'inline-block'}}>
                                                    <img height={100} className={this.state.imageSrc === "" ? "":""} hidden={this.state.imageSrc === ""} src={this.state.imageSrc} alt="PNPicture"/>
                                                </div>
                                                <div style={{display:'inline-block'}}>
                                                    <h1 style={{fontSize: "18pt",textAlign:"left",position:'relative',paddingLeft:10}}>{this.state.currentWord}</h1>
                                                </div>
                                            </div>
                                            <div hidden={this.state.imageSrc === ""} className="row">
                                                <button className="btn btn-success" onClick={() => this.gradePNPicture(1)}>Correct</button>
                                                <button className="btn btn-danger" style={{marginLeft:5}} onClick={() => this.gradePNPicture(2)}>Incorrect</button>
                                                <button className="btn btn-info2" style={{marginLeft:5}} onClick={() => this.gradePNPicture(0)}>Skip</button>
                                            </div>
                                            <div className="row">
                                                <div style={{position:'relative', display:'inline-block'}}>
                                                    <div hidden={!this.state.showReScoreHint} className={"popoverCustom"}>
                                                        <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                                                            <div style={{display:"inline-block",float:'right'}}>
                                                                <img src={closeRedX} onClick={this.getTarget1} style={{width:35,paddingRight:5,cursor:"pointer"}} />
                                                            </div>
                                                            <div style={{display:"inline-block"}}>
                                                                <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint</div>
                                                            </div>
                                                        </div>                                                        Click an icon to re-score
                                                    </div>
                                                    <div hidden={!this.state.showReScoreHint} className={"arrowPointer"}></div>
                                                </div>
                                                {imageThumbnails}
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 paddingTop">
                            <div className="divBottomRelative tr">
                                <a onClick={async ()=>{ await this.setState({
                                    analytics: {
                                        type: TRACKING.PN_SCORE_EXIT,
                                        metadata: {testId: this.state.testId},
                                    }
                                }); this.handleAnalytics(); this.props.history.push('../student')}} className="handBtn fl"><span>Exit</span></a>
                                <a onClick={this.handleNextTask} className="handBtn" style={{ display: this.state.handleNext ? 'inline-block': 'none'}}><span>Next Task</span></a>
                                <a onClick={this.handleTakeANote} className="handBtn" ><span>Make a Note</span></a>
                                <a onClick={this.submitPNSessionGrade} className="handBtn"><span>Save</span></a>
                                <a onClick={this.handleReset} className="handBtn"><span>Reset</span></a>
                                <a onClick={() => {this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'})}} className="handBtn"><span>Delete</span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );

    }
}
const actionToProps = dispatch => {
    return {
        updateStudent: async(student) => await dispatch(updateStudent(student))
    };
};
const mapStateToProps = state => ({
    lastStudent: state.teacherReducer.student,
});
export default connect(mapStateToProps,actionToProps)(withRouter(PNGrading));




// WEBPACK FOOTER //
// ./src/TeachersComponent/PNGrading.js